/**
 * 51esc web — entry point: `/login`.
 *
 * Pantalla de acceso (terminal CRT verde fosforito). Lógica en el
 * módulo `auth`.
 */

import { initLogin } from './modules/auth/index.js';

initLogin();
